import { render, staticRenderFns } from "./EModalSelectBimestres.vue?vue&type=template&id=1a5c12f5&scoped=true"
import script from "./EModalSelectBimestres.vue?vue&type=script&lang=js"
export * from "./EModalSelectBimestres.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a5c12f5",
  null
  
)

export default component.exports